export default __webpack_public_path__ + "static/media/add.ae90a84f.svg";